export const DEFAULT_QUANTITY_COUNT = 1;
export const DEFAULT_NET_PRICE = 0;
export const DEFAULT_NUMBERS_OF_WORK_HOURS = 0;
